import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  sigText: {
    fontSize: 9,
  },
  signature: {
    fontSize: 14,
    height: '1cm',
    width: '60%',
    borderBottom: '1pt solid gray',
  },
  quantities: {
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  quantity: {
    width: '42',
    flexDirection: 'column',
  },
  padBottom5: {
    paddingBottom: 5,
  },
  padBottom10: {
    paddingBottom: 10,
  },
  padTop5: {
    paddingTop: 5,
  },
  padTop15: {
    paddingTop: 15,
  },
  quantityLegend: {
    width: 88,
  },
  productImage: {
    width: 90,
    height: 90,
  },
  productLineItemLineInfo: {
    marginBottom: 2,
  },
  bold: {
    fontFamily: 'Helvetica-Bold',
  },
  col20: {
    width: '20%',
  },
  col40: {
    width: '40%',
  },
  col60: {
    width: '60%',
  },
  col80: {
    width: '80%',
  },
  col50: {
    width: '50%',
  },
  sumRight: {
    width: '84',
    textAlign: 'right',
  },
  blurb: {
    fontSize: 9,
    color: 'gray',
    paddingBottom: 20,
  },
  logo: {
    width: '155px',
    height: '30px',
    marginRight: '7mm',
  },
  textRight: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    right: -20,
    paddingBottom: 4,
  },
  productInfo: {
    color: 'grey',
    paddingRight: 15,
  },
  productDetailsLeft: {
    width: '20%',
  },
  productDetailsRight: {
    width: '80%',
  },
  column: {
    position: {
      width: '7%',
    },
    collection: {
      width: '13%',
    },
    model: {
      width: '34%',
      paddingRight: 20,
    },
    color: {
      width: '12%',
    },
    deliveryDate: { width: '24%' },
    amount: {
      width: '10%',
      textAlign: 'right',
    },
  },
  productLineItemHeader: {
    paddingTop: 5,
    borderTop: '1pt solid gray',
    paddingBottom: 5,
    marginBottom: 15,
    borderBottom: '1pt solid gray',
    fontFamily: 'Helvetica-Bold',
    fontSize: 11,
  },
  productLineItem: {
    fontSize: 9,
    paddingBottom: 10,
    borderBottom: '1pt solid gray',
    marginBottom: 10,
  },
  dl: {
    flexDirection: 'row',
  },
  dd: {
    width: '70',
  },
  dt: {
    width: '100',
  },
  payment: {
    fontSize: 9,
  },
  box: {
    paddingBottom: '4mm',
    color: 'grey',
  },
  black: {
    color: 'black',
  },
  orderInfo: {
    fontSize: 8,
  },
  header: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 16,
    paddingBottom: '10mm',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  row: {
    flexDirection: 'row',
    paddingBottom: 2,
  },
  columna: {
    width: '60%',
    flexDirection: 'column',
  },
  columnb: {
    flexShrink: 1,
  },
  rowHeader: {
    fontFamily: 'Helvetica-Bold',
    color: 'black',
    paddingBottom: 4,
  },
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 8,
    bottom: 30,
    left: 0,
    right: 30,
    fontFamily: 'Helvetica-Bold',
    fontWeight: 'bold',
    textAlign: 'right',
    color: 'black',
  },
  description: {
    fontSize: 10,
    fontFamily: 'Helvetica-Bold',
    color: 'grey',
  },
  normalText: {
    fontSize: 12,
    paddingVertical: 2,
  },
});
